module.exports = __webpack_public_path__ + "img/stock0.b286e54e.png";